
import React from "react";
import { NavLink } from "react-router-dom";

import Logo from '../../atoms/logo/logo';

import './footer.scss'

const Footer = props => {

	return (

        <footer>

		    <div className="footer">

				<div className="fullwidth-content footer__content">

					<div className="footer__logo">

						<Logo />

					</div>

					<ul className="footer__nav">

						<li className="footer__nav-item">

							<NavLink
									className="footer__nav-link"
									to="/sitemap"
									data-intent="informational"
									data-scope="footer"
									data-id="link_content"
									data-text="sitemap link click"
								>
									Sitemap
							</NavLink>

						</li>

						<li className="footer__nav-item">

							<NavLink
									className="footer__nav-link"
									to="/terms-and-conditions"
									data-intent="informational"
									data-scope="footer"
									data-id="link_content"
									data-text="terms and conditions link click"
								>
									Terms & Conditions
							</NavLink>

						</li>

						<li className="footer__nav-item">

							<NavLink
									className="footer__nav-link"
									to="/legal"
									data-intent="transactional"
									data-scope="footer"
									data-id="link_content"
									data-text="legal link click"
								>
									Legal
							</NavLink>

						</li>

						<li className="footer__nav-item">

							<NavLink
									className="footer__nav-link"
									to="/manage-cookies"
									data-intent="transactional"
									data-scope="footer"
									data-id="link_content"
									data-text="legmanage cookies link click"
								>
									Manage Cookies
							</NavLink>

						</li>

							<li className="footer__nav-item">

							<NavLink
									className="footer__nav-link"
									to="/paia-manual"
									data-intent="transactional"
									data-scope="footer"
									data-id="link_content"
									data-text="paia manual link click"
								>
									Paia Manual
							</NavLink>

						</li>

					</ul>

					<div className="footer__copyright">
						©2016 The Standard Bank Tutuwa Community Foundation NPC. The Standard Bank Tutuwa Community Foundation NPC is a registered non-profit company.
					</div>

				</div>

            </div>

		</footer>

	)

}

export default Footer;
